import {FormEventHandler, forwardRef, ReactNode} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubEarningsStatement.module.scss'
import PayStubItem from './PayStubItem'

const cx = cn.bind(s)

interface IFieldsPayStubEarningsStatementProps {
	className?: string
	children?: ReactNode | string
	onChange?: FormEventHandler<HTMLDivElement>
}

const FieldsPayStubEarningsStatement = forwardRef<
	HTMLDivElement,
	IFieldsPayStubEarningsStatementProps
>(({className, children, ...props}, ref) => {
	const payStubStore = usePayStubStore()
	const {items} = payStubStore

	return (
		<div className={cx('stub', className)} {...props} ref={ref}>
			{children}

			{items.map((_, index) => (
				<PayStubItem key={index} index={index} />
			))}
		</div>
	)
})

FieldsPayStubEarningsStatement.displayName = 'FieldsPayStubEarningsStatement'

export default observer(FieldsPayStubEarningsStatement)
